import type { AttributeReviewMappingRow } from "@/hooks/useAttributeReview.types";
import { useLeavingRows } from "@/hooks/useLeavingRows";

import "./reviewMotion.css";

type Props = {
  rows: AttributeReviewMappingRow[];
  groupKey: string;
  renderRow: (row: AttributeReviewMappingRow) => JSX.Element;
};

export function ReviewGroupRows({ rows, groupKey, renderRow }: Props) {
  const shown = useLeavingRows(rows, groupKey);
  return (
    <>
      {shown.map(({ row, ghost }) =>
        ghost ? (
          <div
            key={`gone:${String(row.id)}`}
            aria-hidden
            className="review-row-leaving"
          >
            <div className="min-h-0 overflow-hidden">{renderRow(row)}</div>
          </div>
        ) : (
          renderRow(row)
        ),
      )}
    </>
  );
}
